import axios from 'axios';
import Vue from 'vue';
import router from '@/router';
const wx = require('weixin-js-sdk');
export default {
	data() {
		return {
			// videoUrl: ''
		};
	},
	created() {},
	mounted() {
		let html = document.getElementsByTagName('html')[0];
		let page = document.getElementsByTagName('body')[0];
		setTimeout(() => {
			html.scrollTop = 0;
			page.scrollTop = 0;
		}, 0);
	},
	beforeCreate() {},
	beforeDestroy() {},
	methods: {
		initShare(data = {}) {
			// 分享路径为首页
			// const _url = window.location.href.split('?')[0];
			const _url = window.location.href;
			var shareData;
			const env: any = process.env.VUE_APP_BLUE_DOT;
			const suffix: any = env === 'develop' ? `（测试）` : ``;
			if (JSON.stringify(data) == '{}') {
				shareData = {
					title: '实现可持续3D打印技术在规模生产中的永续发展' + suffix, //标题
					desc: '赢创', //简介
					link: `${_url}`, // 如果页面链接有其他参数需要自己拼接。
					imgUrl: 'http://evonik-wechat.oss-cn-shanghai.aliyuncs.com/uploads/20230505/6454cffd073b3.jpg'
				};
			} else {
				shareData = data;
			}

			wx.ready(function () {
				const prefix = shareData.link.includes('?') ? '&' : '?';
				// shareData.link = shareData.link + prefix;

				// 分享到朋友圈（旧）
				wx.onMenuShareTimeline({
					title: shareData.title,
					desc: shareData.desc,
					link: `${shareData.link}`,
					imgUrl: shareData.imgUrl,
					success: function () {}
				});
				// 分享到朋友圈（新）
				wx.updateTimelineShareData({
					title: shareData.title,
					desc: shareData.desc,
					link: `${shareData.link}`,
					imgUrl: shareData.imgUrl,
					success: function () {}
				});

				// 分享给朋友(旧)
				wx.onMenuShareAppMessage({
					title: shareData.title,
					desc: shareData.desc,
					link: `${shareData.link}`,
					imgUrl: shareData.imgUrl,
					success: function () {}
				});
				// 分享给朋友(新)
				wx.updateAppMessageShareData({
					title: shareData.title,
					desc: shareData.desc,
					link: `${shareData.link}`,
					imgUrl: shareData.imgUrl,
					success: function () {}
				});
			});
		},
		bodyOpen() {
			let body = document.getElementsByTagName('body')[0];
			body.style.overflow = '';
		},
		bodyClose() {
			let body = document.getElementsByTagName('body')[0];
			body.style.overflow = 'hidden';
		},
		goAi() {
			Vue.prototype.$dataStatistics({ event_type: 'click', page_title: '首页' }, 'AI助手');

			// window.location.href = `https://clould-app.lookstar.com.cn/ai/gpt/wechat?tenant=6c3fa2b0-c5be-471d-8c73-4a831e22aea9&project=2403&appid=wxd0e450f42accad28&utm_campaign=TCT%20Asia%202024&utm_source=%E8%85%BE%E8%AE%AF`; //旧
			window.location.href = `https://cloud-app.lookstar.com.cn/ai/gpt/wechat?tenant=6c3fa2b0-c5be-471d-8c73-4a831e22aea9&project=2629&appid=wxd0e450f42accad28&utm_campaign=3D%E6%89%93%E5%8D%B0%E5%BE%AE%E7%AB%99&utm_source=%E8%85%BE%E8%AE%AF`; //新
		}
	}
};
